/**
 * Utilities for Geocoding and Reverse Geocoding using the in-browser Google Maps JS SDK
 */

export interface Coordinates {
  lat: number
  lng: number
}

/**
 * Geocodes an address string or Google Place ID into latitude/longitude coordinates.
 * Runs directly in the browser using window.google.maps.Geocoder.
 */
export async function geocodeAddress(options: {
  address?: string
  placeId?: string
}): Promise<Coordinates | null> {
  const { address, placeId } = options
  if (!address && !placeId) return null

  if (typeof window === 'undefined' || !(window as any).google?.maps?.Geocoder) {
    return null
  }

  try {
    const geocoder = new (window as any).google.maps.Geocoder()
    const request: any = placeId ? { placeId } : { address }

    return await new Promise<Coordinates | null>((resolve) => {
      geocoder.geocode(request, (results: any, status: string) => {
        if (status === 'OK' && results && results[0]?.geometry?.location) {
          const loc = results[0].geometry.location
          const lat = typeof loc.lat === 'function' ? loc.lat() : Number(loc.lat)
          const lng = typeof loc.lng === 'function' ? loc.lng() : Number(loc.lng)
          resolve({ lat, lng })
        } else {
          resolve(null)
        }
      })
    })
  } catch (error) {
    console.warn('Geocoding error in browser Geocoder:', error)
    return null
  }
}
